<div *ngIf="movie" class="branded-page">
  <img
    [ngSrc]="backgroundUrl"
    [alt]="movie?.trTitle + ' background image'"
    class="background-image"
    width="200"
    height="150"
    sizes="100vw"
  />
  <ush-header id="branded-page-header"></ush-header>
  <video *ngIf="backgroundVideo" [src]="backgroundVideo" [muted]="true" loop autoplay></video>
  <div class="container" [ngClass]="{ vertical: template === 'vertical' }">
    <div class="menu-container">
      <div class="logo-section">
        <ush-movie-tell-friends [movie]="movie" [compacted]="true"></ush-movie-tell-friends>
        <div class="logo-wrapper" *ngIf="customMovieLogo || movie.logoUrl">
          <img
            [ngSrc]="customMovieLogo || movie.logoUrl"
            [alt]="movie.trTitle + ' logo'"
            sizes="(max-width: 576px) 60vw, (max-width: 992px) 50vw, 20vw"
            width="200"
            height="150"
          />
          <img
            class="bigger-alternative"
            [ngSrc]="customMovieLogo || movie.logoUrl"
            [alt]="movie.trTitle + ' logo'"
            sizes="(max-width: 576px) 70vw, (max-width: 992px) 50vw, 50vw"
            width="500"
            height="200"
          />
        </div>
        <div *ngIf="movie.logoUrl === undefined && !customMovieLogo" class="branded-movie-title title">
          {{ movie.title }}
        </div>
        <div class="status">{{ movie.releaseMessage }}</div>
        <ng-container *ngIf="channel.socialNetworks?.length > 0">
          <div class="movie-social-section" *ngIf="movie.socialNetworks">
            <ush-social-links [movie]="movie" [socialNetworks]="movie.socialNetworks"></ush-social-links>
          </div>
        </ng-container>
      </div>
      <ul class="menu">
        <!-- TODO: have this part in a iterator and populate from brandedPageLinks -->
        <li *ngFor="let link of brandedPageLinks" [ngClass]="{ selected: section === link.name }">
          <a
            [class]="'menu-' + link.name"
            [ngClass]="{ selected: section === link.name }"
            *ngIf="!link?.isExternal"
            (click)="gotoSection(link)"
            [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)"
            >{{ translateMenu(link.name | cammelCase) }}</a
          >
          <a
            [class]="'menu-' + link.name + ' extra-tab'"
            *ngIf="link?.isExternal"
            queryParamsHandling="preserve"
            [href]="link.link"
            target="_blank"
            (click)="trackingLink(link)"
            [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)"
            >{{ translateMenu(link.name | cammelCase) }}</a
          >
        </li>

        @if (movieMenuExtraElements) {
          <ng-container *ngTemplateOutlet="movieMenuExtraElements" />
        }
      </ul>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <!---->
        <div id="watch-trailer" *ngIf="customMovie?.trailerComponentVisible">
          <ui-video-card
            [video]="{ video: movie.trailerLink, thumbnailUrl: movie.tilePhotoUrl, title: movie.title }"
          ></ui-video-card>
        </div>
        <!---->
        <div *ngIf="watchAtHomeIsAvailable" id="watch-at-home" class="section">
          <ng-container>
            <ng-container *ngIf="hasOnlyOneCountryEnabled">
              <ng-container
                [ngTemplateOutlet]="title"
                [ngTemplateOutletContext]="{ $implicit: 'watch-at-home' }"
              ></ng-container>
            </ng-container>
            <ush-showtime-streaming-watch-at-home
              [movie]="movie"
              (streamingPlatformsLoaded)="onStreamingPlatformsLoaded()"
            ></ush-showtime-streaming-watch-at-home>
          </ng-container>
        </div>

        <div *ngIf="linkIsAvailable('in-cinemas')" id="in-cinemas" class="section">
          <ng-container>
            <ush-showtime-streaming-in-cinemas
              [inCinemasAddon]="brandedInCinemasAddon"
              [movie]="movie"
              (showsLoaded)="onShowtimesLoaded()"
            ></ush-showtime-streaming-in-cinemas>
          </ng-container>
        </div>

        <div id="synopsis-and-cast" class="section">
          <ng-container *ngIf="synopsisTopAddon">
            <ng-container [ngTemplateOutlet]="synopsisTopAddon"></ng-container>
          </ng-container>
          <ush-movie-synopsis [movie]="movie"></ush-movie-synopsis>
          <div *ngIf="synopsisPoster" class="synopsis-poster">
            <img
              [ngSrc]="movie.portraitPhotoUrl || portraitPlaceholder"
              width="225"
              height="350"
              style="height: auto"
              [alt]="movie.title"
              [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }"
            />
          </div>
          <ush-movie-credits [movie]="movie"></ush-movie-credits>
          <ush-movie-more-information [showPortrait]="!synopsisPoster" [movie]="movie"></ush-movie-more-information>
        </div>
        <div *ngIf="movie.trReasonsToWatch" id="reasons-to-watch" class="section">
          <ush-movie-reasons-to-watch [movie]="movie"></ush-movie-reasons-to-watch>
        </div>
        <div *ngIf="movie?.movieImages" id="gallery" class="section">
          <ush-branded-gallery [movieImages]="movie.movieImages"></ush-branded-gallery>
        </div>

        <div *ngIf="demandItEnabled && linkIsAvailable('sign-up')" id="sign-up" class="section">
          <ush-showtime-streaming-subscribe [movie]="movie" [type]="'all'"> </ush-showtime-streaming-subscribe>
        </div>

        @if (usePlaceholderAssets || movie?.hasAssets) {
          <ush-assets-locker-link [movie]="movie" id="assets-locker" class="section" />
        }

        <ng-container *ngFor="let extraSection of brandedExtraSection">
          <div id="{{ extraSection.trName }}" class="section">
            <ng-container [ngTemplateOutlet]="extraSection.contentTemplate"></ng-container>
          </div>
        </ng-container>

        <ush-movie-tell-friends class="footer-share" [movie]="movie" [compacted]="true"></ush-movie-tell-friends>

        <ush-social-links
          class="footer-social"
          [movie]="movie"
          [socialNetworks]="movie.socialNetworks"
        ></ush-social-links>
      </div>
    </div>
  </div>
  <div class="branded-footer" *ngIf="movie.copyrightImageUrl">
    <img
      [ngSrc]="movie.copyrightImageUrl"
      [alt]="movie?.trTitle + ' copyright'"
      sizes="90vw"
      style="width: 100%; height: auto"
      width="500"
      height="150"
    />
  </div>

  <ush-footer id="branded-page-footer" [transparentBackground]="footerTransparentBackground"></ush-footer>
</div>

<ng-template #title let-title>
  <span class="title" [attr.data-translate]="'title.' + (title | cammelCase)">{{
    title | cammelCase | titleLocalize: { defaultValue: title }
  }}</span>
</ng-template>
